import React, { Component } from 'react';
import { Button, Modal } from 'semantic-ui-react'

class ConfirmationModal extends Component {
  render() {
    const { size, title, message, negativeButtonStyle, negativeLabel, negativeCallback, positiveButtonStyle, positiveLabel, positiveCallback } = this.props
    return (
      <Modal size={ size || 'tiny' } dimmer={ 'inverted' } open={ this.props.show } onClose={ () => this.props.negativeCallback() }>
        <Modal.Header>{title}</Modal.Header>
        <Modal.Content>
          { message }
        </Modal.Content>
        <Modal.Actions>
          <Button
            color={negativeButtonStyle || "red"}
            content={negativeLabel}
            onClick={ () => negativeCallback() }
          />
          <Button
            color={positiveButtonStyle || "green"}
            content={positiveLabel}
            onClick={ () => { positiveCallback() } }
          />
        </Modal.Actions>
      </Modal>
    )
  }
}
export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/views/components/modals/confirmation_modal.js